import React, { useEffect, useState } from "react";
import {
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonIcon,
  IonFooter
} from "@ionic/react";
import { documentTextOutline, personOutline } from "ionicons/icons";
import { useDispatch } from "react-redux";
import { LocationSelector } from "./components/LocationSelector";
import { findDocuments } from "../../store/supervisorHome/actions/findDocuments";
import { ActivitySection } from "./components/ActivitySection";
import { UserRolesSection } from "./components/UserRolesSection";
import { findMessages } from "../../store/supervisorHome/actions/findMessages";
import { findUserRoles } from "../../store/supervisorHome/actions/findUserRoles";
import { TodoListSection } from "./components/TodoListSection";

export const SupervisorHome: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    /* dispatch(findMessages()); */
    dispatch(findDocuments());
    dispatch(findUserRoles());
  }, [dispatch]);

  const [acuerdosActive, setAcuerdosActive] = useState<boolean>(true);
  const [colaboradoresActive, setColaboradoresActive] = useState<boolean>(false);


  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light"></IonMenuButton>
          </IonButtons>
          <IonTitle>Supervisión</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense" class="ion-no-border">
          <IonToolbar>
            <IonTitle size="large">Supervisión</IonTitle>
          </IonToolbar>
        </IonHeader>

        <section className="ion-padding">
          <LocationSelector />

          <br />

          <IonGrid class="ion-no-margin ion-no-padding">
            <IonRow className="ion-hide-md-down">
              <IonCol size='12'>
                <IonSegment 
                  value= {acuerdosActive ? "acuerdos" : "colaboradores"} 
                  color="primary"
                  style={{ maxWidth: '100%'}}
                  mode="ios"
                >
                  <IonSegmentButton value="acuerdos" onClick={()=>{setAcuerdosActive(true); setColaboradoresActive(false)}}>
                    <IonLabel style={{display: 'flex', alignItems: 'center'}}><IonIcon icon={documentTextOutline} style={{fontSize:24, marginRight:5}} />Acuerdos</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="colaboradores" onClick={()=>{setAcuerdosActive(false); setColaboradoresActive(true)}}>
                    <IonLabel style={{display: 'flex', alignItems: 'center'}}><IonIcon icon={personOutline} style={{fontSize:24, marginRight:5}} />Colaboradores</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
              </IonCol>
              {acuerdosActive ? (
                <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                  <TodoListSection />
                  {/* <ActivitySection /> */}
                </IonCol> ) : (
                <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                  <UserRolesSection />
                </IonCol>
              )}
            </IonRow>
            <IonRow className="ion-hide-md-up">
             <IonCol size='12'>
                <IonSegment 
                  value= {acuerdosActive ? "acuerdos" : "colaboradores"} 
                  color="secondary"
                  style={{ maxWidth: '100%', position: 'fixed', bottom: 0, left:0, backgroundColor: 'white', zIndex: 1000}}
                  mode="ios"
                >
                  <IonSegmentButton value="acuerdos" onClick={()=>{setAcuerdosActive(true); setColaboradoresActive(false)}}>
                    <IonIcon icon={documentTextOutline} />
                    <IonLabel>Acuerdos</IonLabel>
                  </IonSegmentButton>
                  <IonSegmentButton value="colaboradores" onClick={()=>{setAcuerdosActive(false); setColaboradoresActive(true)}}>
                    <IonIcon icon={personOutline}/>
                    <IonLabel>Colaboradores</IonLabel>
                  </IonSegmentButton>
                </IonSegment>
              </IonCol>
              {acuerdosActive ? (
                <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                  <TodoListSection />
                  {/* <ActivitySection /> */}
                </IonCol> ) : (
                <IonCol sizeLg="12" sizeMd="12" sizeXs="12">
                  <UserRolesSection />
                </IonCol>
              )}

              <IonFooter style={{height:'2rem'}} className="ion-no-border">
              </IonFooter>
            </IonRow>
          </IonGrid>
        </section>
      </IonContent>
    </IonPage>
  );
};
